import { BaseValidator } from './base';
import { call, put, fork, select, take, takeEvery } from 'redux-saga/effects';
import { api }                from 'apps/api'
import { VALID_HEAT_TREATMENT } from 'apps/action_types';
import { FSA }                from 'flux-standard-action';
import { update }             from 'apps/actions/data';
import { deepmerge }          from 'utilities/merge';
import isEmail                from 'validator/lib/isEmail';
import isEmpty                from 'validator/lib/isEmpty';
import { newDataFromDot }     from 'utilities/hash';

class HeatTreatmentValidator extends BaseValidator {
  properties = [
                 'name', 'name_alt',
               ];
  validName(){
    let name = this.newVal.inputs.name.value;
    let isValid = this.require('name', this.messages.common.require)
    if(!isValid){
      this.newVal.error = true;
    }
  }
  validNameAlt(){
    let name = this.newVal.inputs.name_alt.value;
    let isValid = this.require('name_alt', this.messages.common.require)
    if(!isValid){
      this.newVal.error = true;
    }
  }
}
export const validHeatTreatment = function*(){
  yield takeEvery(VALID_HEAT_TREATMENT, function*(action: FSA<any, any>){
    let validator;
    validator = new HeatTreatmentValidator().init(action);
    let method = validator.newVal.method
    let newVal = { error: false };
    if(validator.targetIs('name')){
      validator.validName();
    }
    if(validator.targetIs('name_alt')){
      validator.validNameAlt();
    }
    let newData = newDataFromDot(validator.newVal, action.payload.baseScope)
    yield put(update(newData));
    validator.done();
  });
}
